import BookCoverPage from './BookCoverPage';

// 1. Import Swiper components and styles
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination, Mousewheel } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

const SortedCatalogue = ({ sortedData, onToggle, sortBy = 'Default' }) => {
  if (sortedData.length === 0) {
    return (
      <div className="p-6">
        <p className="text-lg text-slate-500">Nothing to show here.</p>
      </div>
    );
  }

  // Renders the standard multi-row grid
  const renderAsGrid = (books) => (
    <div className="grid grid-cols-2 gap-x-4 gap-y-4 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6">
      {books.map((catalog) => (
        <BookCoverPage
          key={catalog.Path}
          link={catalog.Path}
          imageSrc={`https://baws.in/assets/catalog/${catalog.Filename}`}
          bookLabel={catalog.Label}
          endPage={catalog.EndPage}
          isReading={catalog.isReading}
          onToggle={onToggle}
        />
      ))}
    </div>
  );

  // Renders the single-row Swiper carousel
  const renderAsCarousel = (books) => (
    <div className="relative w-full">
      <Swiper
        modules={[Navigation, Pagination, Mousewheel]}
        navigation={true}
        pagination={{ clickable: true }}
        mousewheel={{
          forceToAxis: true,
        }}
        className="!pb-10"
        // Responsive breakpoints define the number of slides to show
        breakpoints={{
          320: { slidesPerView: 2, spaceBetween: 16 },
          640: { slidesPerView: 3, spaceBetween: 16 },
          768: { slidesPerView: 4, spaceBetween: 16 },
          1024: { slidesPerView: 6, spaceBetween: 16 },
        }}
      >
        {books.map((catalog) => (
          <SwiperSlide key={catalog.Path}>
            <BookCoverPage
              link={catalog.Path}
              imageSrc={`https://baws.in/assets/catalog/${catalog.Filename}`}
              bookLabel={catalog.Label}
              endPage={catalog.EndPage}
              isReading={catalog.isReading}
              onToggle={onToggle}
            />
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );

  return (
    <div className="space-y-2">
      {sortedData.map(([key, value]) => (
        <section key={key} aria-labelledby={key}>
          <h2
            id={key}
            className="mb-6 rounded-md bg-indigo-600 px-4 py-2 text-2xl font-bold text-white shadow-md"
          >
            {key}
          </h2>
          {/* This conditional logic now works correctly with the `sortBy` prop */}
          {sortBy === 'Default' ? renderAsGrid(value) : renderAsCarousel(value)}
        </section>
      ))}
    </div>
  );
};

export default SortedCatalogue;
